export function SwitcherOffIcon() {
  return (
    <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="12" rx="6" fill="currentColor" opacity={0.75} />
      <circle cx="6" cy="6" r="5" fill="white" />
    </svg>
  );
}
